import { Action, createReducer, on } from '@ngrx/store';
import * as AuthActions from './auth-store.actions';
import { AuthState } from './auth-store.state';

export const AUTH_FEATURE_KEY = 'auth';

export interface AuthPartialState {
    readonly [AUTH_FEATURE_KEY]: AuthState;
}

export const initialState: AuthState = {
    loggedIn: false,
    error: undefined,
    loading: false,
    user: undefined
};

const reducer = createReducer(
    initialState,
    on(AuthActions.authLogin, state => ({
        ...state,
        loading: true
    })),
    on(AuthActions.authLoginError, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),
    on(AuthActions.authLoadUser, state => ({
        ...state,
    })),
    on(AuthActions.authUserLoaded, (state, { user }) => ({
        ...state,
        loggedIn: true,
        loading: false,
        user,
    })),
    on(AuthActions.authLoadUserError, (state, { error }) => ({
        ...state,
        loading: false,
    })),
    on(AuthActions.authLoggedOut, state => ({
        ...initialState,
    })),

    on(AuthActions.authForgotPasswordRequest, state => ({
        ...state,
        loading: true
    })),
    on(AuthActions.authForgotPasswordSuccess, state => ({
        ...state,
        loading: false
    })),
    on(AuthActions.authForgotPasswordError, state => ({
        ...state,
        loading: false
    })),

    on(AuthActions.authResetPassword, state => ({
        ...state,
        loading: true
    })),
    on(AuthActions.authResetPasswordSuccess, state => ({
        ...state,
        loading: false
    })),
    on(AuthActions.authResetPasswordError, state => ({
        ...state,
        loading: false
    })),

    on(AuthActions.authSetPassword, state => ({
        ...state,
        loading: true
    })),
    on(AuthActions.authSetPasswordSuccess, state => ({
        ...state,
        loading: false
    })),
    on(AuthActions.authSetPasswordError, state => ({
        ...state,
        loading: false
    }))
);

export function authReducer(state: AuthState | undefined, action: Action) {
    return reducer(state, action);
}
